// Utility function to validate inputs
const validateInput = (username, password) => {
  if (!username || !password) {
    return 'Username and password are required.';
  }
  if (username.length < 2 || username.length > 50) {
    return 'Username must be between 2 and 50 characters.';
  }
  if (password.length < 6 || password.length > 100) {
    return 'Password must be between 6 and 100 characters.';
  }
  return null; // No validation errors
};

export default validateInput;